require('../../sass/base/base.scss');
let ajax = require('../common/ajax/ajax.js');
let Error = require('../../components/error/error.vue');
import Toast from '../../components/toast/toast';
import Vue from 'vue';
import Loading from '../../components/loading';
import { getParam } from '../common/util'
import MobileDetect from 'mobile-detect'
let md = new MobileDetect(window.navigator.userAgent);

xhapp.config({
  debugNoBridge: false
});

new Vue({
  el: '#app',
  data() {
    return {
      loadingShow: true,
      protocolContent: null,
      errorState: {
        show: false,
        tip: null
      },
      obj: JSON.parse(localStorage.getItem('userInfo')) || {}
    }
  },
  created: function() {
    this.fetchData();
  },
  ready: function() {
    // xhTrack.setStep('privacy-policy');
  },
  components: {
    Toast,
    Loading,
    Error,
  },
  methods: {
    fetchData: function() {
      let _this = this;
      let appPackage = getParam('appPackage')  //区分包名 
      let businessGroup = getParam('businessGroup')
      console.log('/h5-loan/protocol/userService/downloadProtocol');
      ajax.post(
        _this,
        '/h5-loan/protocol/userService/downloadProtocol',
        {
          businessGroup: businessGroup || 'BGALL',
          productType: 'BT',
          fundType: 'MDLC',
          wholeSale: false,
          protocolName: 'privacyPolicy',
          appPackage: appPackage || '',
          clientPlatform: appPackage ? md.os() : ''
        },
        function(resp) {
          if (resp.success) {
            _this.protocolContent = resp.protocolContent;  
            $('#protocolContent').html(_this.protocolContent);
            const table = $('table')[0]
            if (table) {
              $(table).css('width', '2100px').wrap('<div style="width: 100%; overflow: auto;"></div>')
            }
          } else {
            _this.$refs.toast.show(resp.resultMsg);
          }
        },
        function(error) {
          _this.errorState = {
            show: true,
            tip: '网络异常，请稍后重试！'
          };
        }
      );
    }   
  }
});




// WEBPACK FOOTER //
// ./web/js/protocols/privacy-policy.js